export const bonuses = [
  {
    label: "Bonus #1",
    title: "The ClinCheck Communication Script Library",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/5kb1fSGqd4P8fMduVjny6B/BONUS_1_CLINCHECK-EN.png",
    headline: "Communicate Your Clinical Questions More Clearly",
    description:
      "When a setup requires revision or clarification, the quality of your communication matters. This resource provides adaptable communication templates to help you explain your observations and specify what needs further discussion.",
    items: [
      "Templates for requesting clarification.",
      "Examples of structured feedback.",
      "Communication prompts for discussing planned movements.",
      "Templates for documenting concerns about attachments.",
      "Follow-up communication examples.",
      "A case-review summary template.",
    ],
    note: "Adapt every template to the individual case and verify that the requested changes reflect your clinical assessment.",
  },
  {
    label: "Bonus #2",
    title: "The 3-Minute ClinCheck Review Checklist",
    value: 27,
    image: "https://cdn.magicpatterns.com/uploads/7JYCrAK66ZrghdSh96wxbD/BONUS_2_CLINCHECK-EN.png",
    headline: "A Quick Reference for Your Pre-Approval Workflow",
    description:
      "Before approving a setup, it helps to have a consistent list of review points. This checklist condenses key review categories into a practical reference you can consult during your workflow.",
    items: [
      "A concise pre-approval checklist.",
      "Diagnostic-record review prompts.",
      "Treatment-objective review points.",
      "Space-management considerations.",
      "Attachment and movement review prompts.",
      "A section for documenting unresolved questions.",
    ],
    note: "The three-minute target refers to a preliminary checklist review, not a complete clinical evaluation of every case.",
  },
  {
    label: "Bonus #3",
    title: "The Clear Aligner Documentation Blueprint",
    value: 29,
    image: "https://cdn.magicpatterns.com/uploads/iCEiUUKbJJzsX5hzuNikFB/BONUS_3_CLINCHECK-EN.png",
    headline: "Organize the Records You Need to Review a Case",
    description:
      "A structured workflow starts with organized information. This resource helps you create a repeatable approach to documenting the information available for each case.",
    items: [
      "A diagnostic-record inventory.",
      "A case information worksheet.",
      "A treatment-objective summary.",
      "A documentation checklist.",
      "A missing-information review sheet.",
      "A case preparation template.",
    ],
    note: "Use it to organize the information required for your own clinical assessment and applicable professional standards.",
  },
  {
    label: "Bonus #4",
    title: "The Aligner Progress Tracking Dashboard",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/ikzDcA6nCjdbi7vVEfArz2/BONUS_4_CLINCHECK-EN.png",
    headline: "Keep Your Treatment Reviews Organized",
    description:
      "Treatment planning is only one part of the process. This editable tracking template helps you document treatment progress, observations, and questions that may require follow-up.",
    items: [
      "A patient case overview template.",
      "A treatment-stage tracking table.",
      "A clinical observation log.",
      "A follow-up planning section.",
      "A refinement discussion record.",
      "A finishing-stage review section.",
    ],
    note: "The dashboard is a documentation aid, not a substitute for direct clinical assessment.",
  },
  {
    label: "Bonus #5",
    title: "The Patient Communication Script Kit",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/6odNN6qfJXcKP5vwi45q57/BONUS_5_CLINCHECK-EN.png",
    headline: "Explain Treatment Decisions With Greater Clarity",
    description:
      "Patients may have questions about aligners, attachments, IPR, treatment duration, and refinements. This resource provides adaptable scripts to help you explain these topics in accessible language.",
    items: [
      "A clear aligner treatment introduction.",
      "An attachment explanation script.",
      "An IPR discussion template.",
      "A treatment-duration communication guide.",
      "A refinement explanation script.",
      "A treatment-expectations checklist.",
    ],
    note: "Adapt the language to the patient's individual circumstances and avoid promising specific treatment outcomes.",
  },
];
